import withWindowState, { WithWindowState } from 'enhancers/withWindowState';
import * as React from 'react';
import styled from 'styled-components';
import Section from 'wrappers/Section/Section';

interface IProps {
  loading: boolean;
  source?: string | boolean;
  className?: string;
}

type Props = WithWindowState & IProps;

export const HomeVideo: React.SFC<Props> = props => {
  let source = typeof props.source === 'string' ? props.source : '';
  const widthRegex = /width="(.*?)"/i;
  const heightRegex = /height="(.*?)"/i;
  const videoWidth = source.match(widthRegex);
  const videoHeight = source.match(heightRegex);
  const padding = 120;
  if (videoWidth && videoWidth[1] && videoHeight && videoHeight[1]) {
    const width = parseInt(videoWidth[1], 10);
    const height = parseInt(videoHeight[1], 10);
    if (props.window.width < width + padding) {
      source = source.replace(
        `width=${width}`,
        `width=${props.window.width - padding + ''}`
      );
      source = source.replace(
        `width="${width}"`,
        `width="${props.window.width - padding + ''}"`
      );

      source = source.replace(
        `height="${height}"`,
        `height="${(height / width) * (props.window.width - padding) + ''}"`
      );
    }
  }

  return (
    <Section className={props.className}>
      <Container>
        <VideoContainer
          dangerouslySetInnerHTML={{
            __html: source
          }}
        />
      </Container>
    </Section>
  );
};

const Container = styled.div`
  padding: 50px;
  display: flex;
  justify-content: center;
`;

const VideoContainer = styled.div`
  width: 80%;
  @media (max-width: 900px) {
    width: 100%;
  }
  @media (max-width: 1200px) {
    width: 100%;
  }
`;

export default withWindowState(HomeVideo);



// WEBPACK FOOTER //
// ./src/components/HomeVideo/HomeVideo.tsx